import ListingCardOnPrivateListingLanding from './ListingCardOnPrivateListingLanding.component';

export default ListingCardOnPrivateListingLanding;
